import React, { useEffect, useState, useRef } from 'react';
import { MapContainer, TileLayer, ImageOverlay } from 'react-leaflet';
import {Marker, 
  Popup, 
  Polygon, 
  LayersControl, 
  LayerGroup,
  useMap, Pane, Tooltip
 } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import 'leaflet-draw/dist/leaflet.draw.css';  // Import Leaflet Draw CSS
import CustomDrawControl from './CustomDrawControl';  // Import your custom control
import { useNavigate } from 'react-router-dom';
import 'leaflet/dist/leaflet.css';

import './App.css';  // Import the CSS file for styling
import Spinner from './Spinner'; 
import PopupCavm from './PopupCavm'
import Downloader from './Downloader';  // Import the Spinner component
import Cookies from 'js-cookie';
import eventEmitter from './eventEmitter';
import eventEmitter1 from './eventEmitter1';
import eventEmitter3 from './eventEmitter3';
import DropdownControl from './DropdownControl';
import DropdownDatasets from './DropdownDatasets';
import ChangeProjection from './ChangeProjection';
import RadioDataset from './RadioDataset'
import Proj from "proj4leaflet";
import proj4 from 'proj4';
import folders from "./separated_folders.json"
import tiles_png from "./tiles-png.json"
import tiles_png_3857 from "./tiles-png-3857.json"
import Colorbar from './Colorbar';
import Colorbardh from './Colorbardh';
import "leaflet-image-transform/dist/L.ImageOverlay.Transform.min.js";
import axios from 'axios';
import L from 'leaflet';
import { useLocation } from "react-router-dom";
import ImageTransformECRG from './ImageTransformECRG';
import { Search } from "lucide-react"; 


const context = require.context('./', false, /^\.\/S1.*\.js$/);

const componentRegistry = {};

context.keys().forEach((key) => {
  const mod = context(key).default;
  const fileName = key.replace('./', '').replace('.js', ''); // S11405141
  const id = fileName.replace(/^S/, ''); // 11405141
  componentRegistry[id] = mod;
});
const MAX_ZOOM = 16;
const TILE_SIZE = 512;

const extent = Math.sqrt(2) * 6371007.2;
const resolutions = Array(MAX_ZOOM + 1)
  .fill()
  .map((_, i) => extent / TILE_SIZE / Math.pow(2, i - 1));

export const ARCTIC_LAEA = new Proj.CRS(
  "EPSG:3575",
  "+proj=laea +lat_0=90 +lon_0=10 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
  {
    origin: [-extent, extent],
    bounds: L.bounds(L.point(-extent, extent), L.point(extent, -extent)),
    resolutions: resolutions,
  }
);

const ARCTIC_TILES_URL =
  "https://tile.gbif.org/3575/omt/{z}/{x}/{y}@4x.png?style=osm-bright-en";

  const crs5936 = new L.Proj.CRS(
    "EPSG:5936",
    "+proj=stere +lat_0=90 +lon_0=-150 +k=0.994 +x_0=2000000 +y_0=2000000 +datum=WGS84 +units=m +no_defs +type=crs",
    {
      origin: [-2.8567784109255E7, 3.2567784109255E7],
      resolutions: [
        238810.81335399998, 119405.40667699999, 59702.70333849987,
        29851.351669250063, 14925.675834625032, 7462.837917312516,
        3731.4189586563907, 1865.709479328063, 932.8547396640315,
        466.42736983214803, 233.21368491607402, 116.60684245803701,
        58.30342122888621, 29.151710614575396, 14.5758553072877, 7.28792765351156,
        3.64396382688807, 1.82198191331174,
      ],
    }
  );
delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

const { BaseLayer, Overlay } = LayersControl;
const MapUpdater = ({ center }) => {
  const map = useMap();
  useEffect(() => {
    map.setView(center);
    
  }, [center, map]);

  return null;
};
const reprojectCoordinates = (coordinates, fromCRS, toCRS) => {
  return coordinates.map(coord => {
    const projectedCoord = proj4(fromCRS, toCRS, [coord[0], coord[1]]); // Reproject the coordinate
    return [projectedCoord[1], projectedCoord[0]]; // Swap to [lat, lon]
  });
};
const CRSUpdater = ({ crs, center, polygons, originalCRS, zoom }) => {
  const map = useMap();

  useEffect(() => {
    if (map && crs) {
      const currentCenter = map.getCenter();
      const currentZoom = zoom;
      const layers = [];

      // Store all tile layers to re-add later
      map.eachLayer(layer => {
        if (layer instanceof L.TileLayer) {
          layers.push(layer);
        }
      });

      // Temporarily remove all layers and reset CRS
      // map.eachLayer(layer => map.removeLayer(layer));
      map.options.crs = crs; // Set new CRS
      
      map.setView(center || currentCenter, currentZoom); // Reset view to the center with new CRS
      
      // Re-add previously removed layers
      layers.forEach(layer => map.addLayer(layer));

      if (polygons) {
        polygons.features.forEach((feature, index) => {
          if (feature.geometry.type === 'Polygon') {
            const codr = feature.geometry.coordinates[0]

            
          }
        });
      }
    }
  }, [crs, center, polygons, originalCRS, zoom, map]);
}

const WGS84 = L.CRS.EPSG3857; 

const epsg3575 = new L.Proj.CRS(
  'EPSG:3575',
  '+proj=stere +lat_0=90 +lon_0=0 +k=0.994 +x_0=2000000 +y_0=2000000 +datum=WGS84 +units=m +no_defs',
  {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128, 64, 32, 16, 8, 4, 2, 1],
    origin: [-20037508.342789244, 20037508.342789244],
  }
);

function App() {
  const [layer, setLayer] = useState('elevation-change');
  const [layer1, setLayer1] = useState('ok');
  const [overlayChecked1, setOverlayChecked1] = useState(true);
  const [overlayChecked3, setOverlayChecked3] = useState(true);
  const [overlayChecked2, setOverlayChecked2] = useState(false);
  const [data, setData] = useState(null);
  const [dataCanadian, setDataCanadian] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [dateRange, setDateRange] = useState({ startDate: '', endDate: '' });
  const [links, setLinks] = useState([]);
  const [linksCanadian, setLinksCanadian] = useState([]);
  const [selectedLink, setSelectedLink] = useState(null);
  const [selectedLinkCanadian, setSelectedLinkCanadian] = useState(null);
  const [downloading, setDownloading] = useState(false); // State to track download progress
  const [progress, setProgress] = useState(0);
  const [warning, setWarning] = useState('');
  const [showWarningModal, setShowWarningModal] = useState(false);
  const [selectedFeature, setSelectedFeature] = useState(null);
  const [timer, setTimer] = useState(0);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const navigate = useNavigate();
  const [selectedLayer, setSelectedLayer] = useState(true);
  const [selectedLayer1, setSelectedLayer1] = useState(true);
  const [folders1, setFolders1] = useState(null);
  const [mapCenter, setMapCenter] = useState([90, 0]);
  const [activeOverlay, setActiveOverlay] = useState('dataset-1');
  const [activecrs, setActiveCrs] = useState(ARCTIC_LAEA);
  const [activecrs1, setActiveCrs1] = useState('001');
  const [activeZoom, setActiveZoom] = useState(5)
  const [markerPosition, setMarkerPosition] = useState(null); 
  const markerRef = useRef(null);
  const markerRef2 = useRef(null);
  const [activeLink, setActiveLink] = useState("#description");
  const [activeBox, setActiveBox] = useState(null);
  const [viewportw, setViewportw] = useState(window.screen.width);

    


// path location
 const location = useLocation();
    
  useEffect(() => {

    setViewportw(window.screen.width);
      
    const token = Cookies.get('token');
    if (token) {
      setIsAuthenticated(true);
    }
  }, [window.screen.width, viewportw]);

// path location end
const params = new URLSearchParams(location.search);
      let id = params.get("id");
      if (!id){
        id = '11311271'
     }
    
const Component = componentRegistry[id];

// fetch dataset
const [dataMap, setDataMap] = useState([]);
const [filteredData, setFilteredData] = useState([]);

  useEffect(() => {
    const fetchDataMap = async (id) => {
      try {
          
        const response = await axios.get(`/api-map`, {
          headers: {
            Authorization: 'taipidata',
          },
        });
        
     const exists = response.data.some(item => item.id_num === id || item.id_code.toLowerCase() === id.toLowerCase() );
     if (!exists){
        id = '11311271'
     }
     const filtered = response.data.filter(item => item.id_num === id || item.id_code.toLowerCase() === id.toLowerCase());
      localStorage.setItem('filtereddata', JSON.stringify(filtered[0]));
        setDataMap(response.data);
        setFilteredData(filtered);
        
      } catch (error) {
        console.error('Error fetching data map:', error);
      }
    };

     
 
          
    fetchDataMap(id);

  }, [location.search]);

// fetch dataset end


const toggleCRS = () => {
    
    
      setActiveCrs(activecrs === ARCTIC_LAEA ? ARCTIC_LAEA : WGS84);
      
   
  };
  const [boundingBox, setBoundingBox] = useState({
    xmin: '',
    xmax: '',
    ymin: '',
    ymax: ''
  });

  
  
  

  const handleLogin = () => {
    setIsAuthenticated(true);
  };

  const handleLogout = () => {
    Cookies.remove('token');
    setIsAuthenticated(false);
  };


 

  useEffect(() => {
    
  fetch(`/api-data`)
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(data => { 
                  const exists = data.some(item => item.id === id || item.id_code.toLowerCase() === id.toLowerCase() );
                 if (!exists){
                    id = '11311271'
                 }
        
                  const filtered_data = data.filter(item => item.id === id || item.id_code.toLowerCase() === id.toLowerCase());
                  setData(filtered_data);
                  
                  })
    .catch(error => setError(error.toString()));
}, [location.search]);

  useEffect(() => {
    // Set up a timer that updates every second
    const interval = setInterval(() => {
      setTimer((prevTimer) => prevTimer + 1);
    }, 1000);

    // Stop the timer and update the message after 5 seconds (for example)
    setTimeout(() => {
      clearInterval(interval);
      setTimeout(() => {
        console.log('Processing Complete!');
      }, 1000);
      
    }, 200000); // Adjust the time as needed

    // Cleanup interval on component unmount
    return () => clearInterval(interval);
  }, []);
  const handleDateChange = (e) => {
    const { name, value } = e.target;
    setDateRange(prevState => ({ ...prevState, [name]: value }));
  };



  
 const handleSubmit = (e) => {
  e.preventDefault(); // Prevent default form submission behavior
 const api = "scrypt:32768:8:1$Lt21wJ8Oo40NAMpT$bd48a82f0959d9e0086eb9476f885bd883f76e7d2e4cfbac1ae7e83861f2a321d95e6912e572f8aef1b3996e096428dc4e776914252768238e2109ecda6f3838"
  if (activeBox===null) return;
  setDownloading(false);
  setLoading(true);

  let bbox1List = []; // List to store bbox strings for each bounding box
  let datalist = [];  // List to store data links from each fetch

  // Function to create bbox1 string
  const createBBoxString = (box) => {
     
    return `${box.xmin},${box.ymin},${box.xmax},${box.ymax}`;
  };

  if (activeBox.length === 1 ) {
    // Handle single bounding box case
    const bbox1 = createBBoxString(activeBox[0]);
   
    bbox1List.push(bbox1);

   fetch(`/api/link?bbox=${bbox1}&dataset=${activeOverlay}`, {
    method: 'GET',  // Or 'POST' depending on your request type
   headers: {
        'api-key': api,
        'Content-Type': 'application/json' 
    }
})
      .then((response) => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then((data) => {
        datalist = data.link || []; // Store the link in datalist
       

        
          setLinks(datalist);
          if (datalist.length > 0) {
            setSelectedLink(datalist[0]);
            setActiveLink("#result");
          } else {
            setActiveLink("#description");
            setSelectedLink(null);
          }
        

        setLoading(false);
        setTimer(0);
      })
      .catch((error) => {
        console.error('Error fetching link:', error);
        setLoading(false);
      });

  } else {
    // Handle multiple bounding boxes
    activeBox.forEach((box) => {
      const bbox1 = createBBoxString(box);
      bbox1List.push(bbox1);
    });

    const fetchPromises = bbox1List.map((bbox1) => {
      return fetch(`/api/link?bbox=${bbox1}&dataset=${activeOverlay}`, {
    method: 'GET',  
    headers: {
        'api-key': api,
        'Content-Type': 'application/json' 
    }
})
        .then((response) => {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          return response.json();
        })
        .then((data) => data.link || [])
        .catch((error) => {
          console.error('Error fetching link for bbox:', bbox1, error);
          return []; // Return empty array on error
        });
    });

    Promise.all(fetchPromises).then((results) => {
      datalist = results.flat(); 
      
        const uniqueData = datalist.filter((value, index, self) => 
  index === self.findIndex((t) => t.name === value.name)
);

      
        setLinks(uniqueData);
        if (datalist.length > 0) {
          setSelectedLink(uniqueData[0]);
          setActiveLink("#result");
        } else {
          setActiveLink("#description");
          setSelectedLink(null);
        }
      

      setLoading(false);
      setTimer(0);
    });
  }
};

  const handlePolygonClick = (feature) => {
    // Reset date range and links when a different polygon is clicked
    if (selectedFeature !== feature) {
      setDateRange({ startDate: '', endDate: '' });
      setLinks([]);
      setSelectedLink(null);
      setSelectedFeature(feature);
    }
  };
  const closeWarningModal = () => {
    setShowWarningModal(false); // Close the modal
  };
  const handleLinkClick = (link,feature1) => {
    
    setSelectedLink(link); 
    
    setMarkerPosition(feature1);
    
    
     // Update selected link for image display
  };

  const handleDownload = () => {
    
    setDownloading(true);
  };
  
  
  

  const handleBoundingBoxChange = (box) => {

      setActiveBox(box)
  };
 const handleReset = (box) => {
    const newLayer = layer1;
    const filtereddata = JSON.parse(localStorage.getItem('filtereddata'));
     
      if (filtereddata) {
      if (newLayer === 'ok'){
        setActiveCrs(crs5936)
    
        setMapCenter([
          parseFloat(filtereddata.center_lat),
          parseFloat(filtereddata.center_lon)
        ])
        setActiveZoom(parseInt(filtereddata.zoom))
       
      }
      if (newLayer === '002'){
        setActiveCrs(WGS84)
        if (filtereddata.id_txt=='dataset-1'){
        setMapCenter([79.5,-81.75])
        setActiveZoom(4)}
        else if (filtereddata.id_txt=='dataset-2'){
        setMapCenter([30,0])
        setActiveZoom(1)}
        else {
        setMapCenter([
          parseFloat(filtereddata.center_lat),
          parseFloat(filtereddata.center_lon)
        ])
        setActiveZoom(parseInt(filtereddata.zoom) - 3)}
      }
      }
  };
    
  const handleBoundingBoxInputChange = (e) => {
    const { name, value } = e.target;
    setBoundingBox(prevState => ({ ...prevState, [name]: value }));
  };

  useEffect(() => {
    const handleLayerChange = (newLayer) => {
      
      setLayer(newLayer);
      setSelectedLayer(newLayer);
      
    };

    eventEmitter.on('layerChanged', handleLayerChange);

    // Cleanup on component unmount
    return () => {
      eventEmitter.off('layerChanged', handleLayerChange);
    };
  }, []);

   
  useEffect(() => {
      
      if (!localStorage.getItem('crs')){
      localStorage.setItem('crs', 'ok'); 
        localStorage.setItem('namecrs', 'Arctic Stereographic');}
      
      const newLayer = localStorage.getItem('crs');
    
      setLayer1(newLayer);
      setSelectedLayer1(newLayer);
     if (filteredData.length > 0) {
      if (newLayer === 'ok'){
        setActiveCrs(crs5936)
    
        
        setMapCenter([
          parseFloat(filteredData[0].center_lat),
          parseFloat(filteredData[0].center_lon)
        ])
        setActiveZoom(parseInt(filteredData[0].zoom))
       
      }
      if (newLayer === '002'){
        setActiveCrs(WGS84)
        if (filteredData[0].id_txt=='dataset-1'){
        setMapCenter([79.5,-81.75])
        setActiveZoom(4)}
        else if (filteredData[0].id_txt=='dataset-2'){
        setMapCenter([30,0])
        setActiveZoom(1)}
        else if (filteredData[0].id_txt=='dataset-3'){
        setMapCenter([30,0])
        setActiveZoom(1)}
        else {
         setMapCenter([
          parseFloat(filteredData[0].center_lat),
          parseFloat(filteredData[0].center_lon)
        ])
        setActiveZoom(parseInt(filteredData[0].zoom) - 3)}
      }
      }
      else {
        if (newLayer === 'ok'){
        setActiveCrs(crs5936)
    
         setMapCenter([90, 0])
        setActiveZoom(5)
       
      }
      if (newLayer === '002'){
        setActiveCrs(WGS84)
        setMapCenter([30,0])
        setActiveZoom(1)
      }
          
      }
    
    
  }, [activecrs,localStorage.getItem('crs'), filteredData]);

     
const prevLayerRef = useRef(null); 
useEffect(() => {
  if (filteredData.length === 0) return;

  const newLayer = filteredData[0].id_txt;


  if (prevLayerRef.current !== newLayer) {
    setSelectedLink(null);
    setSelectedLinkCanadian(null);
    setLinks([]);
    setLinksCanadian([]);
    setActiveOverlay(newLayer);


    prevLayerRef.current = newLayer;
  }

}, [filteredData]);

  
  
  const imageOverlayRef = useRef(null);
  useEffect(() => {
    if (imageOverlayRef.current) {
      imageOverlayRef.current.bringToFront();  // Bring the image overlay to the front
    }
  }, [activeOverlay]);  // Trigger the effect when activeOverlay changes

    // Inside your component
useEffect(() => {
   
  if (activeBox) {
    // Automatically submit the form
      setMarkerPosition(null)
    handleSubmit(new Event('submit'));
  }
    
}, [activeBox]);

// Automatically open the popup when the selected link changes
  useEffect(() => {
    if (markerRef.current && selectedLinkCanadian) {
      markerRef.current.openPopup(); // Open the popup directly on the marker ref
    }
    if (markerRef2.current && selectedLink) {
      markerRef2.current.openPopup(); // Open the popup directly on the marker ref
    }
  }, [selectedLinkCanadian, selectedLink]);

    const consoleError = console.error;
console.error = (message, ...args) => {
  if (message.includes('Each child in a list should have a unique "key" prop')) {
    return; // Ignore this specific warning
  }
  consoleError(message, ...args); // Log other warnings as usual
};


const [query, setQuery] = useState('');

const resultQuery = dataMap.filter(item => {
  const combinedText = `${item.title_content} ${item.id_code}`;
  return combinedText.toLowerCase().includes(query.toLowerCase());
});

const [showInner, setShowInner] = useState(false);


  return (
    
    <div className={`App  pt-0 -mt-0 min-h-[800px] relative`}>
  
      

      <div className={`Map-container flex ${viewportw < 900 ? 'flex-col' : 'flex-row'} min-h-[800px] z-3`}>
        
        <MapContainer minZoom={2} center={mapCenter}  crs={activecrs} zoom={activeZoom}  className={`Map  w-[98%] h-[800px] shadow-md pr-6 pl-6 bg-white rounded-md`}>
       
        <CRSUpdater crs={activecrs} center={mapCenter} polygons={dataCanadian} originalCRS={activecrs} zoom={activeZoom}/>
       
    {/*<RadioDataset  />*/}
 


{filteredData.length > 0 && (
     <DropdownControl input={filteredData} layer1={layer1} />
)}
        


        
          
      


         
          
          {/* Add the CustomDrawControl component for drawing tools */}
          <CustomDrawControl onBoundingBoxChange={handleBoundingBoxChange} layer1={layer1} overlay={activeOverlay} valueReset1={handleReset}/>
          
              
          { data && data.map((feature, index) => {
            
              const parsedCoordinates = JSON.parse(feature.coordinates_4326);
             
            return (
              <Polygon style={{ zIndex: 10000 }}
                key={index}
                positions={parsedCoordinates[0].map(coord => [coord[1], coord[0]])}
                pathOptions={{
                  fillColor: 'blue',
                  fillOpacity: 0,
                  color: 'blue',
                  weight: 1,
                  opacity: 0.5
                }}
                eventHandlers={{
                  click: () => handlePolygonClick(feature)
                }}
              >
                     <Tooltip>{feature.name === "Raster-CAVM-GIS-data.zip"? '': feature.name}</Tooltip>
                <Popup>
                  <center>
                  <strong>{feature.name}</strong><br /><br />
                 
                  
                    <a href={feature.data} target="_blank">
                      <button className="download-button" onClick={handleDownload}>
                            Download
                          </button>
                          </a>
                    </center>
                  
                </Popup>
              </Polygon>
              
            ) 
          })}





{selectedLink && markerPosition && (

        
              <Polygon
                positions={markerPosition}
                ref={markerRef2}
                pathOptions={{
                  fillColor: 'blue',
                  fillOpacity: 0,
                  color: 'red',
                  weight: 1,
                  opacity: 0.5
                }}
              >
                   <Tooltip>{selectedLink.name}</Tooltip>
                 <Popup>
                  <center>
                  <strong>{selectedLink.name}</strong><br /><br />
                 
                   
                    <a href={selectedLink.data} target="_blank">
                      <button className="download-button" onClick={handleDownload}>
                            Download
                          </button>
                          </a>
                     </center>
                  
                </Popup>
              </Polygon>
                  )}






<div className="opacity-10">
{data && data.length>0 && activeOverlay === "dataset-2" && layer.toLowerCase() !== "none" && (
    <>
    
  <Pane name="image-pane"  pathOptions={{
                  fillColor: 'blue',
                  fillOpacity: 0,
                  color: 'red',
                  weight: 1,
                  opacity: 0
                }} style={{ zIndex: 100 }}>
  
        <ImageTransformECRG className="z-[100]"
          data={data}
          activeOverlay={activeOverlay}
          layer1={layer1}
          layer={layer}
          setLoading={setLoading}
              
        />
</Pane>
      </>
)}
    </div>

{activeOverlay==="dataset-1" && layer1 === 'ok' && layer.toLowerCase() === "elevation-change" && tiles_png &&
    <Pane name="image-pane" style={{ zIndex: 200 }}>
      {tiles_png.map((tiles, index) => (
        tiles.type.dh !== '' && (
          <ImageOverlay
            className="z-[100]"
            key={index}
            url={`/storage/tiles-png/tiles/${tiles.type.dh}`} 
            bounds={tiles.bounds} 
            opacity={parseFloat(localStorage.getItem('opacity'))}

          />
        )
      ))}
    </Pane>
}

{activeOverlay==="dataset-1" && layer1 === '002' && layer.toLowerCase() === "elevation-change" && tiles_png_3857 &&
    <Pane name="image-pane" style={{ zIndex: 200 }}>
      {tiles_png_3857.map((tiles, index) => (
        tiles.type.dh !== '' && (
          <ImageOverlay
            className="z-[100]"
            key={index}
            url={`/storage/3857-tiles-png/${tiles.type.dh}`} 
            bounds={tiles.bounds} 
            opacity={parseFloat(localStorage.getItem('opacity'))}

          />
        )
      ))}
    </Pane>
}


{Component && 
    <>
        <Component className="z-[100]" style={{ zIndex: 100 }}
            setLoading={setLoading}
            data={data}
          activeOverlay={activeOverlay}
          layer1={layer1}
          layer={layer}
              
        />
      </>
}





{ filteredData.length > 0 && filteredData[0].cb_link !=='' &&
<Colorbardh input={filteredData}/> }
        </MapContainer>
    <div className="p-0 lg:p-[10px]"></div>
        <div className={` form-container ${viewportw < 900 ? 'w-[100%]' : 'w-[40%]'} shadow-md pr-6 pl-6 bg-white rounded-md`}>

   <div className="flex items-center border-[2px] border-[#015ecc] rounded overflow-hidden">
      <input
        type="text"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        placeholder="Search Dataset..."
        className="px-3 w-full text-black focus:outline-none"
      />
      <div className="p-1">
        <Search className="w-5 h-5 text-[#015ecc]" />
      </div>
    </div>

{query && (
  <div className="p-6 h-[80vh] overflow-y-auto rounded-xl space-y-6">
    
    {resultQuery.length === 0 ? (
      <div className="p-6 border border-gray-300 rounded-lg shadow-md bg-white text-center">
        <p className="text-gray-700 text-lg font-medium">🔍 No results found for your search.</p>
      </div>
    ) : (
      resultQuery.map((item, i) => (
        <a
          key={i}
          href={`/map?id=${item.id_code}`}
          className="block border border-gray-200 hover:border-blue-600 bg-white rounded-xl shadow-md hover:shadow-lg transition-all duration-300 p-6"
        >
          <p className="text-gray-800 text-base font-semibold hover:text-blue-600">
            {item.title_content}
          </p>
        </a>
      ))
    )}
  </div>
)}


            
            <div className={`${query ? "hidden":""}`}>
        <div className="navdes flex text-black flex-row">
            <a
            href="#description"
            className={activeLink === "#description" ? "active mr-[0.3rem]" : ""}
            onClick={() => setActiveLink("#description")}
          >
            <p className="pr-2 border border-blue-500 pl-2 rounded-sm shadow-sm"> Description</p>
              </a>
              <a
            href="#result"
            className={activeLink === "#result" ? "active ml-[0.3rem]" : ""}
            onClick={() => setActiveLink("#result")}
          >
             <p className="pr-2 border border-blue-500 pl-2 rounded-sm shadow-sm">Query results</p>
              </a>
        </div>
  {/* Form content */}
{activeLink==='#description' && ( <>
     <div className="flex justify-left item-left">
    <div className='text-black'>
         {filteredData.map(item => (
             <div key={item.id}>
             
         
    
   
        <div className="flex flex-col">
        <span className="text-[11px]  mb-[-5px] text-gray-500"> Dataset {item.id_num}; <a className="text-blue-500" href={item.doi}> 
     {item.doi} </a> 
     </span>
         <zero-md>
      <script
        type="text/markdown"
        dangerouslySetInnerHTML={{
          __html: `${item.short_description}
`
        }}
      />
    </zero-md>
            </div>
 </div>
            
   ))}
</div>
    
    </div>
        </>
        )}
    


        
{localStorage.getItem('crs') === '002' && id === '11405141' && (
       <div className="spinner-container flex justify-center items-center">
      <PopupCavm />
    </div> )}

  {loading ? (
    <div className="spinner-container flex justify-center items-center">
      <Spinner />
    </div>
  ) : (
    <span></span>
  )}

{activeLink === '#result' && (
  <>
    {activeBox === null && (
      <div className="text-n-8 mt-[20px]">Please draw at least one shape to get the results</div>
    )}
    
    {activeBox !== null && links.length > 0 && (
      <div className="text-n-8">{links.length} subsets of the data lie within the selected area:</div>
    )}

    <div className={`${links.length > 0 ? "popup-content-wrapper" : ""}`}>
      <div className={`${links.length > 0 ? "popup-text" : ""}`}>
      
        




{activeBox !== null ? (
          links.map((link, linkIndex) => {
         
          const parsedCoordinates = JSON.parse(link.coordinates_4326);
              const geometries = parsedCoordinates[0].map(coord => [coord[1], coord[0]]);
              
         
            return (
              <div key={linkIndex} className="link-container mb-2">
                <a
                  href="#"
                  className={`link text-blue-500 ${selectedLink === link ? 'active-link' : ''}`}
                  onClick={(e) => {
                    e.preventDefault();
                    handleLinkClick(link, geometries);
                  }}
                >
                  {linkIndex + 1}. {link.name}
                </a>
                <br />
              </div>
            );
          })
        ) : (
          <span></span>
        )}




        
      </div>
    </div>

    <div className="mt-0">
      
      {activeBox !== null && selectedLink && (
        <div>
          <a href={selectedLink.data} target="_blank" rel="noopener noreferrer">
            <button className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600">
              Download
            </button>
          </a>
          <div className="h-[20px]" />
          <p className="text-black">Preview {selectedLink.name}:</p>
          <img
            src={selectedLink.thumbnail}
            alt="Preview"
            className="w-auto h-[250px] my-2"
          />
          
        </div>
      )}
    </div>
  </>
)}
    </div>
</div>

      </div>
    </div>


  );
}

export default App;
